import { apiDate, PDF_FILE_TYPE } from '@/platform/lib/utils';
import {
    Button,
    Checkbox,
    Divider,
    FormGroup,
    Input,
    Segment,
    SegmentContent,
} from '@/platform/ui';
import { Link, usePage } from '@inertiajs/react';

const ContractTypes = ({ data, onChange, errors }) => {
    const { auth, is_vcsw, types } = usePage().props;

    if (!is_vcsw) {
        return null;
    }

    const handleCheckbox = fileType => {
        const selected = data?.files || [];

        onChange(
            'files',
            selected.includes(fileType)
                ? selected.filter(current => current !== fileType)
                : [...selected, fileType]
        );
    };

    return (
        <>
            <Divider content='Voorbeeld & verzenden' />

            {types.map(type => (
                <Segment key={type.value}>
                    <SegmentContent>
                        <FormGroup>
                            <Checkbox
                                value={type.value}
                                checked={data?.files?.includes(type.value)}
                                label={type.label.replace(
                                    'Machtiging',
                                    'Machtiging meerdere entiteiten'
                                )}
                                onChange={() => handleCheckbox(type.value)}
                            />

                            {data?.id && (
                                <p className='flex gap-4'>
                                    {auth.permissions?.includes(
                                        'update contract content'
                                    ) && (
                                        <Button
                                            as={Link}
                                            type='button'
                                            variant='link'
                                            href={`/contracts/${data?.id}/contents?template=${type.value}`}
                                        >
                                            Aanpassen
                                        </Button>
                                    )}
                                    <Button
                                        as={Link}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        type='button'
                                        variant='link'
                                        href={`/contracts/${data?.id}/preview?template=${type.value}`}
                                    >
                                        Voorbeeld
                                    </Button>
                                </p>
                            )}

                            {!data?.signed_at && (
                                <Input
                                    type='file'
                                    accept={PDF_FILE_TYPE}
                                    onChange={event =>
                                        onChange(
                                            `uploads.${type.value}`,
                                            event.target.files[0]
                                        )
                                    }
                                    error={errors?.[`uploads.${type.value}`]}
                                />
                            )}
                            {type.value === 'zekerheid_maand' &&
                                data?.files?.includes(type.value) && (
                                    <Input
                                        label={`Factuurdatum ${type.value}`}
                                        name='invoice_date'
                                        type='date'
                                        value={
                                            apiDate(data?.invoice_date) || ''
                                        }
                                        required
                                        onChange={event =>
                                            onChange(
                                                'invoice_date',
                                                event.target.value
                                            )
                                        }
                                    />
                                )}
                        </FormGroup>
                    </SegmentContent>
                </Segment>
            ))}

            <em className='text-xs'>
                Algemene Voorwaarden en Privacy Statement worden automatisch
                meeverzonden.
            </em>
        </>
    );
};

export default ContractTypes;
